const RENDERING_DEFAULTS = {
  MINIMUM_SLAB_THICKNESS: 5e-2,
  MAXIMUM_RAY_DISTANCE: 1e6,
};

Object.freeze(RENDERING_DEFAULTS);

export default RENDERING_DEFAULTS;
